import formScheme from '../formScheme';

const config = {
  fields: [
    'eventType',
    'responsible',
    'game',
    'platform',
    'dateTime',
    'appVersion',
    'minAppVersion',
    'maxAppVersion',
    'serverVersion',
    'notesLink',
    'description',
    'audience',
    'channel',
    'resolutionDate',
    'techTag',
    'classTag',
    'typeTag',
    'engineVersion',
  ],
  validate: formScheme,
};

export default config;
